import { formatHundredths } from '../decimal.ts';

/** The sentence a circle's prompts and a round solid's volume share (ADR 0140 §4). */
const piSentence = () => `Usa 3.14 para pi.`;

/** Spanish circle prompts (ADR 0106 §3). Mexico and the United States write a decimal point. */
export const circlePrompts = {
    piSentence,
    circumference: () => `Halla la circunferencia. ${piSentence()}`,
    area: () => `Halla el área. ${piSentence()}`,
    diameterFromCircumference: (circumference: string) =>
        `La circunferencia es ${circumference}. ${piSentence()} ¿Cuál es el diámetro?`,
    decimal: (hundredths: number) => formatHundredths(hundredths, '.'),
};
